import Authentification from './authentification'
import { VUE_APP_ROOT_API } from '@/helpers/env'
import I18n from '@/helpers/i18n'

export async function uploadImage(file) {
  try {
    const { fileId } = await upload('image', file)
    return fileId
  } catch {
    throw new Error(I18n.t('image-upload-error'))
  }
}

export async function uploadTempFile(file) {
  const { fileId } = await upload('tempFile', file)
  return fileId
}

export async function uploadPublicFile(file) {
  return await upload('publicFile', file)
}

async function upload(uploadType, file) {
  // Make sure auth token will be valid
  await Authentification.renewToken()

  const token = Authentification.getUserToken()
  const data = new FormData()
  data.append('file', file)

  const response = await fetch(`${VUE_APP_ROOT_API}/upload/${uploadType}`, {
    method: 'post',
    headers: {
      Authorization: `Bearer ${token}`
    },
    body: data
  })

  if (response.status === 200) {
    return await response.json()
  } else {
    throw new Error(I18n.t('file-upload-error'))
  }
}
